// Externe Bibliotheken
import React, { Component } from 'react';
import axios from 'axios';
import { Navigate } from 'react-router';
import { Scrollbar } from 'smooth-scrollbar-react';

// Interne Module
import * as storage from '@/_helper/storage';
import tracking from '@/_helper/tracking';
import { getSearchParams } from '@/_helper/searchParamsHelper';
import { redirectToPage } from '@/_helper/checkAccess';
import { withRouter } from '@/_helper/withRouter';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import { SingleDateInput } from '@/comp/form/dateInput/SingleDateInput';
import Button from '@/comp/button/button';

// Styles
import './login.scss';

// Assets
import logo from '@/assets/img/logo-short.png';

const params = {
    errorWording: {
        lastname: 'Der Nachname stimmt nicht mit unserem System überein.',
        bookingnumber: 'Die Buchungsnummer stimmt nicht mit unserem System überein.',
        travelstart: 'Das Datum stimmt nicht mit unserem System überein.',
    },
};

class Index extends Component {
    constructor(props) {
        super(props);

        // init focus input trigger
        this.bookingnumber = React.createRef();
        this.lastname = React.createRef();
        this.travelstart = React.createRef();
        let searchParams = getSearchParams();

        this.state = {
            lastname: '',
            bookingnumber: '',
            travelstart: '',
            lastnameValid: false,
            travelstartValid: false,
            bookingnumberValid: false,
            autologout:
                searchParams && searchParams['autologout'] !== undefined && searchParams['autologout'][0] === 'true',
            error: false,
            formErrors: {
                lastname: '',
                bookingnumber: '',
                travelstart: '',
            },
            formValid: false,
            formVacancy: false,
            formSubmit: false,
            params: storage.get('params') !== null ? storage.get('params') : this.props.match?.params,
        };

        this.handleUserInput = this.handleUserInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        // deeplink
        if (this.props.location?.pathname?.indexOf('deeplink') > 0) {
            const { mode } = this.props.params;
            storage.remove('params');
            storage.remove('mode');

            // all params
            storage.set('params', this.props.location?.pathname);

            // mode
            if (mode !== undefined) {
                storage.set('mode', mode);
            }
        }
    }

    componentDidMount() {
        document.title = window.$documentTitle.slice(3);

        document.querySelector('html').classList.add('redesign');

        tracking('loaded', 'doorPage');

        // affiliate
        if (window.$affiliate) {
            const { hash, target } = this.props.params;
            let $this = this;
            // todo: remove in next releases
            storage.remove('deeplink');

            if (hash !== undefined) {
                // remove old access_token
                storage.remove('access_token');

                setTimeout(function () {
                    // remove old access_token
                    storage.remove('access_token');
                    $this.hashAutoLogin(hash, target);
                }, 0);
            } else {
                // Todo: Zeige Login Page?
                //storage.clear();
            }
        }

        // get tab sync : login vacancy
        if (storage.get('loginVacancy')) {
            document.title = 'Sie werden eingeloggt | ' + window.$documentTitle.slice(3);
            this.setState({
                formValid: true,
                formVacancy: true,
                formSubmit: true,
            });
        }
        window.addEventListener('beforeunload', function () {
            storage.remove('loginVacancy');
        });
    }

    handleUserInput(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({ [name]: value }, () => {
            if (name !== 'bookingnumber' || (name === 'bookingnumber' && value.length === 9)) {
                this.validateField(name, value);
            }
        });
    }

    handleDateInputChange(name, value, valid) {
        this.setState({ travelstart: value, travelstartValid: valid }, () => {
            this.validateField(name, value);
        });
    }

    resetTrigger(e) {
        if (this.state[e].length) {
            return (
                <div
                    className="reset-trigger"
                    onClick={(event) => {
                        this.setState({ [e]: '' });
                        this[e].current.focus();
                    }}>
                    <i className="material-icons">clear</i>
                </div>
            );
        }
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let lastnameValid = this.state.lastnameValid;
        let bookingnumberValid = this.state.bookingnumberValid;

        switch (fieldName) {
            case 'lastname':
                // lastnameValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                lastnameValid = value.length > 0;
                fieldValidationErrors.lastname = lastnameValid ? '' : params.errorWording.lastname;
                break;
            case 'bookingnumber':
                // bookingnumberValid = value.length >= 6;
                // fieldValidationErrors.bookingnumber = bookingnumberValid ?  '' : params.errorWording.bookingnumber ;
                bookingnumberValid = value.match(/^[0-9]{9,}$/i) !== null;
                fieldValidationErrors.bookingnumber = bookingnumberValid ? '' : params.errorWording.bookingnumber;
                break;
            default:
                break;
        }

        this.setState(
            {
                formErrors: fieldValidationErrors,
                bookingnumberValid: bookingnumberValid,
                lastnameValid: lastnameValid,
            },
            this.validateForm
        );
    }

    validateForm() {
        this.setState({
            formValid: this.state.lastnameValid && this.state.bookingnumberValid && this.state.travelstartValid,
        });
    }

    errorClass(error) {
        return error.length === 0 ? '' : 'has-error';
    }

    hashAutoLogin(hash, target) {
        let $this = this;

        if (hash === undefined) {
            return false;
        }

        this.setState({
            formSubmit: true,
        });

        let loginData = {
            action: 'login',
            clientId: 'customerarea',
            requestType: 'bookingData',
            hash: hash,
        };

        // remove old access_token
        storage.remove('access_token');

        // default
        axios({
            url: window.$serviceUrl + '/bookingData?token=' + window.$token,
            method: 'POST',
            data: loginData,
        })
            .then((response) => response)
            .then(function (response) {
                if (response.data.data.hash !== null) {
                    let bookingId = response.data.data.bookingId;
                    let travelStart = response.data.data.travelStart;
                    let lastName = response.data.data.firstPaxName;
                    if (bookingId && travelStart && lastName) {
                        if (target !== undefined) {
                            sessionStorage.setItem('redirect_page', '/' + target);
                        }
                        storage.remove('params');

                        $this.handleLogin(response, bookingId, travelStart, lastName);
                    } else {
                        // hash not valid
                        storage.remove('params');

                        if (window.$affiliate === 'ch24') {
                            const bookingData = storage.get('bookingData');
                            let backURL = null;
                            if (bookingData?.data) {
                                backURL =
                                    new URL(bookingData.data.pbeHash).origin +
                                    new URL(bookingData.data.pbeHash).pathname;
                            } else {
                                backURL = 'https://kundenbereich.check24.de/';
                            }
                            window.location.href = backURL;
                        } else {
                            window.location.reload();
                        }
                    }
                } else {
                    throw new Error(response.data.data.errorMessage);
                }
            })
            .catch((error) => {
                this.setState({ error, formVacancy: false, formSubmit: false });
                window.location.href = 'https://kundenbereich.check24.de';
            });
    }

    handleSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }

        this.setState({
            error: false,
            formSubmit: true,
        });

        // form validation
        if (!this.state.formValid) {
            // form is invalid! so we do nothing

            // set error dialogs
            let fieldValidationErrors = this.state.formErrors;
            fieldValidationErrors.lastname = params.errorWording.lastname;
            fieldValidationErrors.bookingnumber = params.errorWording.bookingnumber;
            fieldValidationErrors.travelstart = params.errorWording.travelstart;

            this.setState({
                formErrors: fieldValidationErrors,
            });

            return;
        }

        this.setState({
            formVacancy: true,
        });

        let travelStart;
        let d = this.state.travelstart.split('.');
        travelStart = d[0] + '.' + d[1] + '.' + d[2];

        // set tab sync : login vacancy
        storage.set('loginVacancy', true);

        // login data
        const loginData = {
            requestType: 'bookingData',
            action: 'login',
            bookingId: this.state.bookingnumber,
            firstPaxName: this.state.lastname,
            travelStart: travelStart,
            clientId: 'customerarea',
            requestSource: 'AurumTours-Customerarea',
        };

        let lastname = this.state.lastname;
        let bookingnumber = this.state.bookingnumber;
        let $this = this;

        // default
        axios({
            url: window.$serviceUrl + '/bookingData?token=' + window.$token,
            method: 'POST',
            data: loginData,
        })
            .then((response) => response)
            .then(function (response) {
                if (response.data.data.hash !== null) {
                    $this.handleLogin(response, bookingnumber, travelStart, lastname);
                } else {
                    throw new Error(response.data.data.errorMessage);
                }
            })
            .catch((error) => this.setState({ error, formVacancy: false }));
    }

    getLoginErrorText(errorReason) {
        switch (errorReason) {
            case 'flight':
                return (
                    'Ihr Login in den Kundenbereich ist derzeit nicht möglich. <br/>' +
                    'Bitte wenden Sie sich per E-Mail an unser Serviceteam unter <a href="mailto:service@aurumtours.de">service@aurumtours.de</a> für Unterstützung.'
                );
            case 'cruise':
                return (
                    'Für Buchungen von Kreuzfahrten steht der Kundenbereich noch nicht zur Verfügung.' +
                    ' Bitte wenden Sie sich per E-Mail an unser Serviceteam unter <a href="mailto:service@aurumtours.de">service@aurumtours.de</a> für Unterstützung.'
                );
            default:
                return (
                    'Es ist ein Fehler aufgetreten. Bitte prüfen Sie Ihre Daten und geben Sie diese erneut ein. Bitte achten' +
                    'Sie auch darauf, keine Leerzeichen hinter Ihrem Nachnamen einzugeben.'
                );
        }
    }

    handleLogin(response, bookingNumber, travelStart, lastname) {
        let bookingData = response?.data?.data;

        storage.remove('loginVacancy');

        if (bookingData?.data?.allowedInteractions?.login?.allowed === false) {
            this.setState({
                formVacancy: false,
                error: true,
                errorText: this.getLoginErrorText(bookingData.data.allowedInteractions.login.reason),
            });
            return false;
        }

        storage.remove('logout');
        storage.set('login', true);
        storage.set('bookingData', bookingData);

        storage.set('bookingNumber', bookingNumber);
        storage.set('travelStart', travelStart);
        storage.set('firstPaxName', lastname);
        storage.set('access_token', response.data.data.hash);
        storage.set('login_timestamp', new Date().getTime());

        // loggedIn
        let domain = window.location.hostname;
        if (window.location.hostname.split('.').length > 1) {
            domain =
                window.location.hostname.split('.')[window.location.hostname.split('.').length - 2] +
                '.' +
                window.location.hostname.split('.')[window.location.hostname.split('.').length - 1];
        }
        document.cookie =
            'loggedIn=true;expires=' +
            new Date().setMonth(new Date().getMonth() + 12) +
            ';domain=' +
            domain +
            ';path=/;secure;SameSite=Strict';

        // auto redirect to page / deep link
        redirectToPage(this.props?.location);
        tracking('loaded', 'login');
    }

    render() {
        if (storage.get('login') != null) {
            if (!window.$affiliate) {
                return <Navigate to="/" />;
            }
        }

        return (
            <>
                {
                    // if affiliate and has hash value
                    window.$affiliate && this.props.params?.hash !== undefined && this.props.params.hash.length > 0 ? (
                        <div className="page-login auto">
                            {this.state.formSubmit === true && (
                                <>
                                    <div className="loading">
                                        <span className="loading-ptr-1"></span>
                                        <span className="loading-ptr-2"></span>
                                        <span className="loading-ptr-3"></span>
                                    </div>
                                </>
                            )}
                        </div>
                    ) : (
                        <div className="page-login">
                            <Header login={false} />
                            <div className="page-content">
                                {window.$browserInfo.device !== 'mobile' && <div className="image"></div>}

                                <div className="login-mask">
                                    <Scrollbar>
                                        <div
                                            className={`login-cnt 
												${this.state.formVacancy ? 'validate' : ''} 
												${this.state.autologout ? 'auto-logout' : ''}`}>
                                            {this.state.autologout && (
                                                <div className="auto-logout-layer" key="autologoutlayer">
                                                    <i className="material-symbols-outlined">timer</i>
                                                    <div>
                                                        Sie waren zu lange inaktiv. Deshalb wurden Sie aus
                                                        Sicherheitsgründen ausgeloggt.
                                                    </div>
                                                </div>
                                            )}

                                            <form
                                                className="form-signin txtL"
                                                autoComplete="off"
                                                onSubmit={this.handleSubmit}
                                                method="post"
                                                noValidate="">
                                                <div className="head">
                                                    {window.$affiliate ? (
                                                        (() => {
                                                            switch (window.$affiliate) {
                                                                case 'ch24':
                                                                    return <></>;
                                                                default:
                                                                    return <img src={logo} alt="AurumTours" />;
                                                            }
                                                        })()
                                                    ) : (
                                                        <>
                                                            <img src={logo} alt="AurumTours" />
                                                        </>
                                                    )}
                                                </div>

                                                <div className="content txtL">
                                                    <div className="text">
                                                        {window.$affiliate ? (
                                                            (() => {
                                                                switch (window.$affiliate) {
                                                                    case 'ch24':
                                                                        return <h2>Kundenbereich</h2>;
                                                                    default:
                                                                        return <h2>AurumTours Kundenbereich</h2>;
                                                                }
                                                            })()
                                                        ) : (
                                                            <>
                                                                <h2>AurumTours Kundenbereich</h2>
                                                            </>
                                                        )}

                                                        <p>Verwalten Sie hier Ihre gebuchte Reise.</p>
                                                    </div>

                                                    {window.$deactivateLogin && (
                                                        <p className="error midoco">
                                                            Leider ist unser Kundenbereich gerade nicht erreichbar.{' '}
                                                            <br />
                                                            Bitte wenden Sie sich bei dringenden Fragen an den
                                                            AurumTours Service.
                                                        </p>
                                                    )}

                                                    {!window.$deactivateLogin && (
                                                        <>
                                                            <div
                                                                className={`input-field  ${this.errorClass(
                                                                    this.state.formErrors.bookingnumber
                                                                )} ${this.state.bookingnumberValid ? 'valid' : ''} `}>
                                                                <label className="sr-only" htmlFor="bookingnumber">
                                                                    Buchungsnummer
                                                                    <i className="material-symbols-outlined">
                                                                        info
                                                                        <div className="tooltip">
                                                                            Die Buchungsnummer finden Sie in Ihren
                                                                            Reiseunterlagen oder in der
                                                                            Buchungsbestätigung, die Sie per E-Mail
                                                                            erhalten haben.
                                                                        </div>
                                                                    </i>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bookingnumber"
                                                                    inputMode="numeric"
                                                                    ref={this.bookingnumber}
                                                                    className="form-control reset-input"
                                                                    onChange={(event) => this.handleUserInput(event)}
                                                                    onBlur={() =>
                                                                        this.validateField(
                                                                            'bookingnumber',
                                                                            this.state.bookingnumber
                                                                        )
                                                                    }
                                                                    maxLength={9}
                                                                    value={this.state.bookingnumber.replace(/\D/g, '')}
                                                                />

                                                                {this.resetTrigger('bookingnumber')}

                                                                {this.state.formSubmit === true &&
                                                                    this.state.bookingnumberValid === false &&
                                                                    this.state.formErrors.bookingnumber.length > 0 && (
                                                                        <p
                                                                            className="error"
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: this.state.formErrors
                                                                                    .bookingnumber,
                                                                            }}></p>
                                                                    )}
                                                            </div>

                                                            <div
                                                                className={`input-field  ${this.errorClass(
                                                                    this.state.formErrors.lastname
                                                                )} ${this.state.lastnameValid ? 'valid' : ''} `}>
                                                                <label className="sr-only" htmlFor="lastname">
                                                                    Nachname
                                                                    <i className="material-symbols-outlined">
                                                                        info
                                                                        <div className="tooltip lastname">
                                                                            Bitte verwenden Sie den Nachnamen des 1.
                                                                            Reiseteilnehmers laut Rechnung für den
                                                                            Login. Die Reihenfolge kann von Ihrem
                                                                            Check24-Kundenkonto abweichen.
                                                                        </div>
                                                                    </i>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="lastname"
                                                                    ref={this.lastname}
                                                                    className="form-control reset-input"
                                                                    onChange={(event) => this.handleUserInput(event)}
                                                                    onBlur={() =>
                                                                        this.validateField(
                                                                            'lastname',
                                                                            this.state.lastname
                                                                        )
                                                                    }
                                                                    value={this.state.lastname}
                                                                />

                                                                {this.resetTrigger('lastname')}

                                                                {this.state.formSubmit === true &&
                                                                    this.state.lastnameValid === false &&
                                                                    this.state.formErrors.lastname.length > 0 && (
                                                                        <div className="error">
                                                                            {this.state.formErrors.lastname}
                                                                        </div>
                                                                    )}
                                                            </div>

                                                            <SingleDateInput
                                                                classList="input-field"
                                                                errorText={params.errorWording.travelstart}
                                                                label="Anreisedatum"
                                                                name="travelstart"
                                                                validate={this.state.formSubmit === true}
                                                                handleChange={this.handleDateInputChange.bind(this)}
                                                                value={
                                                                    this.state.travelstart ? this.state.travelstart : ''
                                                                }
                                                            />
                                                        </>
                                                    )}
                                                </div>

                                                {!window.$deactivateLogin && (
                                                    <>
                                                        <div className="btn-cnt">
                                                            <Button
                                                                classList={'txtR '}
                                                                label={
                                                                    this.state.formVacancy
                                                                        ? 'Sie werden eingeloggt'
                                                                        : 'Einloggen'
                                                                }
                                                                valid={this.state.formValid}
                                                                validated={this.state.formVacancy}
                                                                icon="arrow_forward"
                                                                type="submit"
                                                            />
                                                        </div>
                                                        {this.state.error &&
                                                            (this.state.errorText ? (
                                                                <div
                                                                    className="error txtR"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: this.state.errorText,
                                                                    }}></div>
                                                            ) : (
                                                                <div className="error txtR">
                                                                    Es ist ein Fehler aufgetreten. Bitte prüfen Sie Ihre
                                                                    Daten und geben Sie diese erneut ein. Bitte achten
                                                                    Sie auch darauf, keine Leerzeichen hinter Ihrem
                                                                    Nachnamen einzugeben.
                                                                </div>
                                                            ))}
                                                    </>
                                                )}

                                                {window.$testLoginAllowed === 'true' && (
                                                    <span
                                                        style={{
                                                            background: 'black',
                                                            color: 'white',
                                                            cursor: 'pointer',
                                                            position: 'absolute',
                                                            top: '0',
                                                            left: '0',
                                                            zIndex: '10',
                                                        }}
                                                        onClick={(e) =>
                                                            this.setState({
                                                                bookingnumber: window.$content.fakeLogin.bookingnumber,
                                                                lastname: window.$content.fakeLogin.lastname,
                                                                travelstart: window.$content.fakeLogin.travelstart,
                                                                lastnameValid: true,
                                                                bookingnumberValid: true,
                                                                travelstartValid: true,
                                                                formValid: true,
                                                            })
                                                        }>
                                                        set test login data
                                                    </span>
                                                )}
                                            </form>
                                        </div>
                                    </Scrollbar>
                                </div>
                            </div>

                            <Footer />
                        </div>
                    )
                }
            </>
        );
    }
}

export default withRouter(Index);
